import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";
import {EditionApiModel} from "../../api/models/edition.api-model";

export class EditionViewModel extends AbstractDictionaryViewModel<EditionApiModel> {
  public fullName: string;
  public year: string;
  public yearFrom: string;
  public yearTo: string;
  public years: string;
  public displayName: string;
  constructor(protected apiModel: EditionApiModel) {
    super(apiModel);
    this.fromApiModel(apiModel);
  }

  fromApiModel(apiModel: EditionApiModel): EditionViewModel {
    super.fromApiModel(apiModel);
    this.fullName = apiModel.fullName;
    this.year = apiModel.year;
    this.yearFrom = apiModel.yearFrom;
    this.yearTo = apiModel.yearTo;

    const yearFrom = this.yearFrom || null;
    const yearTo = this.yearTo || null;
    if (yearFrom || yearTo) {
      this.years = `${yearFrom || '?'} - ${yearTo || '?'}`;
      this.displayName = `${this.name} (${this.years})`;
    } else if (this.fullName) {
      this.displayName = this.fullName;
      this.years = this.year || '';
    } else if (this.year) {
      this.years = this.year;
      this.displayName = `${this.name} (${this.year})`;
    } else {
      this.years = '';
      this.displayName = this.name;
    }

    return this;
  }
}
